export const BookingColumns = [
  { title: "Booking ID", field: "bookingId", isLink: true },
  { title: "Booking Status", field: "bookingStatus" },
  { title: "State", field: "careStateRegion" },
  { title: "Email", field: "email" },
  { title: "Name", field: "name" },
  { title: "Checked In ?", field: "selfCheckinComplete" },
  { title: "DOB", field: "dob" },
  { title: "Products", field: "products" },
  {title:"Care Location", field:"careLocation"}
];
export const KIT_COLUMNS = [
  { title: "Kit Id", field: "kitId", isLink: true },
  { title: "Email", field: "email" },
  { title: "Name", field: "name" },
  { title: "DOB", field: "dob" },
  { title: "Clinician Name", field: "clinicianName" },
  { title: "Kit Status", field: "kitStatus" },
  { title: "Registration State", field: "registrationState" },
  { title: "Lab Name", field: "labName" },
  { title: "Created", field: "created" },
  { title: "Sample Taken Date", field: "sampleTakenDate" },
  {title:"Care Location", field:"careLocation"}
];
export const TEST_RESULT_COLUMNS = [
  { title: "Kit Id", field: "kitId", isLink: true },
  { title: "Patient Name", field: "name" },
  { title: "clinician Name", field: "clinicianName" },
  { title: "DOB", field: "dob" },
  { title: "Email", field: "email" },
  { title: "Sample Taken Date", field: "sampleTakenDate" },
  { title: "Received Date", field: "receivedDate" },
  { title: "Status", field: "summaryStatus" },
  { title: "Test Result Status", field: "testResultStatus" },
  {title:"Care Location", field:"careLocation"}
];
export const ORDER_PENDING_SHIPMENT_COLUMNS = [
  { title: "Order Id", field: "orderId", isLink: true },
  { title: "Order Status", field: "orderStatus" },
  { title: "Order Date", field: "orderCreateDate" },
  { title: "Email", field: "email" },
  { title: "Vendor", field: "vendor" },
  {title:"Care Location", field:"careLocation"}
];
export const data = [{ location: "LVS", date: "02/18/24 10:00 am", patientName: "Harsh Dangi", status: "Confirmed", checkedIn: "Yes" }];
